"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('germs', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 44C25.3357 44 26.3638 40.2497 27.6262 40C28.9267 39.7427 30.4588 42.9787 31.6554 42.4825C32.8729 41.9777 32.4053 38.8666 33.4874 38.1421C34.5781 37.412 37.2174 39.0668 38.1421 38.1421C39.0668 37.2174 36.6639 34.0907 37.3941 33C38.1186 31.9178 41.9777 32.8729 42.4825 31.6554C42.9787 30.4588 39.179 28.1131 39.4362 26.8125C39.686 25.5502 44 25.3357 44 24C44 22.6643 40.2497 21.3593 40 20.0969C39.7427 18.7964 42.9787 17.5412 42.4825 16.3446C41.9777 15.1271 38.1186 16.0822 37.3941 15C36.6639 13.9093 39.0668 10.7826 38.1421 9.85786C37.2174 8.93315 34.0907 10.9489 33 10.2187C31.9178 9.49427 32.8729 6.02232 31.6554 5.51747C30.4588 5.02129 28.3005 7.90438 27 7.6471C25.7376 7.39738 25.3357 4 24 4C22.6643 4 22.12 7.39738 20.8577 7.6471C19.5571 7.90438 17.5412 5.02129 16.3446 5.51747C15.1271 6.02232 16.0822 9.1334 15 9.85786C13.9093 10.588 10.7826 8.93315 9.85786 9.85786C8.93315 10.7826 11.5248 13.9093 10.7947 15C10.0702 16.0822 6.02232 15.1271 5.51747 16.3446C5.02129 17.5412 8.25728 19.2393 8 20.5398C7.75028 21.8022 4 22.6643 4 24C4 25.3357 8.09721 25.9271 8.34694 27.1894C8.60421 28.49 5.02129 30.4588 5.51747 31.6554C6.02232 32.8729 9.80669 31.9178 10.5312 33C11.2613 34.0907 8.93315 37.2174 9.85786 38.1421C10.7826 39.0668 13.9093 36.8547 15 37.5849C16.0822 38.3093 15.1271 41.9777 16.3446 42.4825C17.5412 42.9787 19.5571 39.7427 20.8577 40C22.12 40.2497 22.6643 44 24 44Z",
    fill: props.outFillColor,
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinejoin: props.strokeLinejoin
  }), _react.default.createElement("path", {
    d: "M29 29C31.2091 29 33 27.2091 33 25C33 22.7909 31.2091 21 29 21C26.7909 21 25 22.7909 25 25C25 27.2091 26.7909 29 29 29Z",
    fill: props.innerFillColor,
    stroke: props.innerStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinejoin: props.strokeLinejoin
  }), _react.default.createElement("path", {
    d: "M16.5 26C17.8807 26 19 24.8807 19 23.5C19 22.1193 17.8807 21 16.5 21C15.1193 21 14 22.1193 14 23.5C14 24.8807 15.1193 26 16.5 26Z",
    fill: props.innerStrokeColor
  }));
});

exports.default = _default;